module.exports = __webpack_public_path__ + "static/media/products-landing-hero-desktop-1440x300.5b9b85fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/products/assets/products-landing-hero-desktop-1440x300.jpg
// module id = 1110
// module chunks = 1